module.exports = __webpack_public_path__ + "img/catharina-maria-bugge-p.43330125.jpg";